"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var i18next = require("i18next");
var i18nextXHRBackend = require("i18next-xhr-backend");
var BASE_URL = 'https://cashier-services.wix.com/cashier-metadata/api/v1/locales/cashier-payments-sdk';
var _init = null;
var i18nInstance = null;
if (process.env.NODE_ENV !== 'production') {
    _init = function (lng, resources, onReady) {
        if (resources === void 0) { resources = {}; }
        i18nInstance = i18next.createInstance()
            .init({
            lng: lng,
            keySeparator: '$',
            fallbackLng: 'en',
            interpolation: {
                escapeValue: false
            },
            resources: {
                en: {
                    translation: require('./../../src/assets/locale/messages_en.json')
                }
            }
        }, function (err, t) {
            onReady && onReady(t);
        });
        return i18nInstance;
    };
}
else {
    _init = function (lng, resources, onReady) {
        if (resources === void 0) { resources = {}; }
        i18nInstance = i18next
            .createInstance()
            .use(i18nextXHRBackend)
            .init({
            lng: lng,
            keySeparator: '$',
            fallbackLng: 'en',
            interpolation: {
                escapeValue: false
            },
            backend: {
                loadPath: BASE_URL + "/{{lng}}",
                crossDomain: true
            }
        }, function (err, t) {
            onReady && onReady(t);
        });
        return i18nInstance;
    };
}
exports.init = _init;
exports.translate = function (key, data) {
    if (data === void 0) { data = {}; }
    return i18nInstance.t(key, data);
};
exports.errorCodeToMessage = function (code, locale, data) {
    if (locale === void 0) { locale = 'en'; }
    if (data === void 0) { data = {}; }
    var key = "payment_error_" + code;
    var message = i18nInstance.t(key, Object.assign({}, data, { lng: locale, fallbackLng: 'en' }));
    if (message && message !== key) {
        return message;
    }
    return '';
};
exports.default = i18nInstance;
//# sourceMappingURL=i18n.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/cashier-payments-sdk/dist/src/utils/i18n.js
// module id = 416
// module chunks = 0 1